<ng-container
  [ngTemplateOutlet]="template"
  [ngTemplateOutletContext]="{
    advancedSearchEnabled: advancedSearchEnabled$ | async,
    flattenedUsers: (flattenedUsers$ | async) ?? [],
    results: results$ | async,
    search: search$ | async
  }"
>
</ng-container>

<ng-template
  #template
  let-advancedSearchEnabled="advancedSearchEnabled"
  let-flattenedUsers="flattenedUsers"
  let-results="results"
  let-search="search"
>
  <div flexLayout="column" flexLayoutAlign="start stretch" class="container">
    @if (flattenedUsers.length > 0) {
      @if (advancedSearchEnabled) {
        <table mat-table matSort [dataSource]="results" (matSortChange)="sortChangeHandler($event)">
          <ng-container matColumnDef="profileFirstName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
            <td mat-cell *matCellDef="let element">
              <span
                [innerHTML]="
                  element.user.userName | searchHighlight: element.matches : 'userName' : search
                "
              ></span>
            </td>
          </ng-container>
          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
            <td mat-cell *matCellDef="let element">
              <span
                [innerHTML]="
                  element.user.userEmail | searchHighlight: element.matches : 'userEmail' : search
                "
              ></span>
            </td>
          </ng-container>
          <ng-container matColumnDef="lastLoginDateTime">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Login</th>
            <td mat-cell *matCellDef="let element">
              <span
                [innerHTML]="
                  element.user.userLastLoginDate
                    | searchHighlight: element.matches : 'userLastLoginDate' : search
                "
              ></span>
            </td>
          </ng-container>
          <ng-container matColumnDef="active">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>User State</th>
            <td mat-cell *matCellDef="let element">
              <span
                [innerHTML]="
                  element.user.active | searchHighlight: element.matches : 'active' : search
                "
              ></span>
            </td>
          </ng-container>
          <ng-container matColumnDef="userRoles">
            <th mat-header-cell *matHeaderCellDef>Roles</th>
            <td mat-cell *matCellDef="let element">
              <span
                [innerHTML]="
                  element.user.userRoles | searchHighlight: element.matches : 'userRoles' : search
                "
              ></span>
            </td>
          </ng-container>
          <ng-container matColumnDef="userTags">
            <th mat-header-cell *matHeaderCellDef>Tags</th>
            <td mat-cell *matCellDef="let element">
              <span
                [innerHTML]="
                  element.user.userTags | searchHighlight: element.matches : 'userTags' : search
                "
              ></span>
            </td>
          </ng-container>
          <ng-container matColumnDef="actions" stickyEnd="true">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let element">
              <div class="actions" flexFill flexLayout="row" flexLayoutAlign="end center">
                <button
                  mat-icon-button
                  [disableRipple]="true"
                  *ngxPermissionsOnly="[permConst.Admin.User.Profile.Write]"
                  [routerLink]="['/administration/user', element.user.userId]"
                  [queryParams]="{ returnUrl: 'users' }"
                >
                  <mat-icon>edit</mat-icon>
                </button>
              </div>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
          <tr
            mat-row
            *matRowDef="let element; columns: columnsToDisplay"
            [ngClass]="{ 'enabled-link': isRouterLinkEnabled }"
            (dblclick)="editUser(element.user.userId)"
          ></tr>
        </table>
      } @else {
        <table
          mat-table
          matSort
          [dataSource]="flattenedUsers"
          (matSortChange)="sortChangeHandler($event)"
        >
          <ng-container matColumnDef="profileFirstName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
            <td mat-cell *matCellDef="let element">
              {{ element.userName }}
            </td>
          </ng-container>
          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
            <td mat-cell *matCellDef="let element">{{ element.userEmail }}</td>
          </ng-container>
          <ng-container matColumnDef="lastLoginDateTime">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Login</th>
            <td mat-cell *matCellDef="let element">
              {{ element.userLastLoginDate | date: "M/d/yy, HH:mm" }}
            </td>
          </ng-container>
          <ng-container matColumnDef="active">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>User State</th>
            <td mat-cell *matCellDef="let element">{{ element.active ? "Active" : "Inactive" }}</td>
          </ng-container>
          <ng-container matColumnDef="userRoles">
            <th mat-header-cell *matHeaderCellDef>Roles</th>
            <td mat-cell *matCellDef="let element">{{ element.userRoles }}</td>
          </ng-container>
          <ng-container matColumnDef="userTags">
            <th mat-header-cell *matHeaderCellDef>Tags</th>
            <td mat-cell *matCellDef="let element">{{ element.userTags }}</td>
          </ng-container>
          <ng-container matColumnDef="actions" stickyEnd="true">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let user">
              <div class="actions" flexFill flexLayout="row" flexLayoutAlign="end center">
                <button
                  mat-icon-button
                  [disableRipple]="true"
                  *ngxPermissionsOnly="[permConst.Admin.User.Profile.Write]"
                  [routerLink]="['/administration/user', user.userId]"
                  [queryParams]="{ returnUrl: 'users' }"
                >
                  <mat-icon>edit</mat-icon>
                </button>
              </div>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
          <tr
            mat-row
            *matRowDef="let user; columns: columnsToDisplay"
            [ngClass]="{ 'enabled-link': isRouterLinkEnabled }"
            (dblclick)="editUser(user.userId)"
          ></tr>
        </table>
      }
    }
  </div>
</ng-template>
